import { BadImplementationException, randomNumber } from "@nu-art/ts-common";
export function resolveWidth(width, randomWidthRange = [50, 150]) {
    switch (typeof width) {
        case 'number':
            return `${width}px`;
        case 'string': {
            if (width === 'random') {
                const randomWidth = randomNumber(randomWidthRange);
                return `${randomWidth}px`;
            }
            if (width.at(-1) === '%')
                return width;
            throw new BadImplementationException(`Unknown string format '${width}'`);
        }
        default:
            throw new BadImplementationException(`Unhandled width argument type ('${typeof width}'): ${width}`);
    }
}
//# sourceMappingURL=consts.js.map